<div class='MoveContacts pb-5'>
  <div class='MoveContacts__header mb-5 d-flex flex-row justify-content-between'>
    <div class='Breadcrumbs align-content-center'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/user_contacts', 'user_groups']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a
          [routerLink]="['/user_contacts', 'user_groups']"
          class='Breadcrumbs-item first'
        >Contacts</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>Move Contacts</span>
      </div>
    </div>
    <div class='MoveContacts__header__buttons d-flex flex-row justify-content-around align-items-center'>
      <mat-slide-toggle (change)='toggleTable($event)'>Show table</mat-slide-toggle>
      <app-button [Click]='uploadButtonProperties.onClick' [color]='uploadButtonProperties.color'
                  [disabled]='showUploadingWarning'
                  [size]='uploadButtonProperties.size'
                  [text]='uploadButtonProperties.text' class='ms-5'></app-button>
    </div>
  </div>
  <div *ngIf='showUploadingWarning' class='row'>
    <div class='col col-12 alert alert-warning'>
      <p>Your move contacts request is currently being processed. Please wait.</p>
    </div>
  </div>
  <app-table
    #tableComponent
    (rowSelected)='onSelection($event)'
    *ngIf='tableReady'
    [class.hidden]='!showTable'
    [columns]='tableColumns'
    [dataSourceParams]='tableDataSourceParams'
    [dataSource]='dataSource'
    [filterGroups]='tableFilterGroups'
    [selectable]='true'
    [useRouteNavigation]='false'></app-table>
</div>
